export default {
    namespaced: true,

    state: {
        displayContextMenu: false,
        contextMenuInitiatorId: null,
        contextMenuPosition: {x: 0, y: 0},
    },

    getters: {

    },

    mutations: {
        setDisplayContextMenu(state, status) {
            state.displayContextMenu = status;
        },

        setContextMenuInitiatorId(state, id) {
            state.contextMenuInitiatorId = id;
        },

        setContextMenuPosition(state, position) {
            state.contextMenuPosition = position;
        },

    },

    actions: {
        openContextMenu({rootState, commit}, {id, position}) {

            if (rootState.editor.drawingState) return;

            commit('setContextMenuInitiatorId', id);

            commit('setContextMenuPosition', position);

            commit('setDisplayContextMenu', true);
        },

        closeContextMenu({commit, dispatch}) {

            commit('setDisplayContextMenu', false);

            dispatch('editor/backUserToDrawAction', null, {root: true})
        },

    },
}